export default __webpack_public_path__ + "static/media/alipay_logo.87d1e0c8.svg";